export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M8 8h40l8 8v40H16l-8-8z" fill="#F5A524" />
    <path d="M18 18h8v20h12v8H18z" fill="#0B0C10" />
    <path d="M34 18h12v6h-12zM34 28h9v5h-9z" fill="#0B0C10" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3 group">
    <span className="transition-transform duration-500 group-hover:rotate-[-8deg] group-hover:scale-105">
      <LogoMark />
    </span>
    <span className="leading-none">
      <span className="block font-display font-black text-lg tracking-wide text-white">LAWRENCE'S</span>
      <span className="block font-mono text-[10px] tracking-[0.45em] text-[#F5A524]">EMPORIO</span>
    </span>
  </span>
);
